import { render } from "./DatesOverview.vue?vue&type=template&id=61ec977e&scoped=true"
import script from "./DatesOverview.vue?vue&type=script&lang=js"
export * from "./DatesOverview.vue?vue&type=script&lang=js"

import "./DatesOverview.vue?vue&type=style&index=0&id=61ec977e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ec977e"]])

export default __exports__